export enum PublicDevelopmentManagerDetailsPreviewParams {
  previewUuid = "previewUuid",
}
